export function countWord(text: string) {
  return text.length === 0 ? 0 : text.trim().split(/\s+/).length;
}
